import { Injectable } from '@angular/core';
import { MarkerClusterService } from './marker-cluster.service';
import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { GoogleMapsAPIWrapperService } from '../google-map-wrapper/google-maps-api-wrapper.service';
import { GoogleMapHTTPService } from 'src/app/modules/aa-core/services/google/google-map-http/google-map-http.service';
import { AAGoogleMarkerService } from 'src/app/modules/aa-core/services/google/google-marker/aa-google-marker.service';
import { ITrafficAlertCarkPark, ITrafficAlertsTopHits } from 'src/app/core/models/models';
import { TrafficAlertType, AAClusterType } from '../../enums/google-map-enum';
import { GoogleMapOptionsEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapOptionsModel } from '../../models/google-map-model';
import { GoogleInfoWindowService } from '../google-info-window/google-info-window.service';

@Injectable({
  providedIn: 'root'
})
export class TrafficAlertMarkerService extends MarkerClusterService {

  private trafficAlertsData: Array<ITrafficAlertCarkPark>;
  private trafficAlertsMarker: Array<any> = [];

  constructor(
    private aaMarkerService: AAGoogleMarkerService,
    private eventsService: EventsService,
    private googleHttp: GoogleMapHTTPService,
    private googleInfoWindow: GoogleInfoWindowService,
    private mapsWrapper: GoogleMapsAPIWrapperService) {
    super();
    this.eventsService.on(GoogleMapOptionsEvents.TRAFFIC_ALERT_CHANGED, this.onTrafficAlertChanged);
    this.eventsService.on(GoogleMapOptionsEvents.CLEAR_CLRSTER_DATA, this.clearAll.bind(this));
  }

  private incidentOrder: Array<string> = [
    TrafficAlertType.ROAD_CLOSURES,
    TrafficAlertType.INCIDENTS,
    TrafficAlertType.ROADWORKS,
    TrafficAlertType.CONGESTION,
    TrafficAlertType.LANE_CLOSED,
    TrafficAlertType.WEATHER_INCIDENTS];

  // load traffic alert data;
  public loadTrafficAlertData = (googleMap: IGoogleMap, incidentTypes?: Array<string>): void => {
    this.googleHttp.getTrafficNewsData(this.getBoundinBoxData(googleMap), incidentTypes).subscribe(data => {
      this.trafficAlertsData = data;
      this.trafficAlertsMarker = this.addTrafficAlertMarker(this.trafficAlertsData, googleMap);

      this.eventsService.dispatch(GoogleMapOptionsEvents.TRAFFIC_ALERT_UPDATED, new Date());
    },
      error => { console.log(error); }
    );
  }

  private onTrafficAlertChanged = (params: {googleMap: IGoogleMap, options: GoogleMapOptionsModel, reload?: boolean}): void => {
    // console.log('TrafficAlert >>>>>>', options, this.trafficAlertsMarker);
    this.googleInfoWindow.close();

    if (this.trafficAlertsMarker && this.trafficAlertsMarker.length && params.reload !== true) {
      for (let markerConter = 0; markerConter < this.trafficAlertsMarker.length; markerConter++ ) {
        const taMarker = this.trafficAlertsMarker[markerConter];
        // || params.options.CurrentTraffic
        taMarker.setVisible(params.options.TrafficAlert);
      } // || params.options.CurrentTraffic
    } else if (params.options.TrafficAlert ) {
      this.loadTrafficAlertData(params.googleMap);
    }
  }

  public clearAll(): void {
    this.trafficAlertsMarker.forEach(marker => {
      marker.setMap(null);
    });
    this.trafficAlertsMarker = [];
  }

  public addTrafficAlertMarker = (trafficAlertsData: Array<ITrafficAlertCarkPark>, googleMap: IGoogleMap) => {
    this.clearAll();

    const trafficAlertsMarker: Array<any> = [];
    for (let markerCounter = 0; markerCounter < trafficAlertsData.length; markerCounter++) {
      const trafficCarModel: ITrafficAlertCarkPark = trafficAlertsData[markerCounter];
      const dummyMarkerCount: number = trafficCarModel.hitCount - trafficCarModel.topHits.length;

      // check zoomLevel < 18 just to make sure, no cluster on street level;
      if (dummyMarkerCount > 0 && googleMap.getZoom() < 18) {
        const marker = this.aaMarkerService.createClusterMarker(googleMap, trafficCarModel, trafficCarModel.hitCount,
           AAClusterType.TRAFFIC_ALERT_CLUSTER);
        trafficAlertsMarker.push(marker);
      } else {
        let topHits = trafficCarModel.topHits;

        if (googleMap.getZoom() >= 17) {
          topHits = this.removeDuplicateSortTrafficAlertOnSameLocation(topHits);
        }

        for (let tophitCounter = 0; tophitCounter < topHits.length; tophitCounter++) {
          const topHitModel: ITrafficAlertsTopHits = topHits[tophitCounter] as ITrafficAlertsTopHits;
          const marker = this.aaMarkerService.createTrafficAlertMarker(topHitModel, googleMap, true, this.mapsWrapper.getTrafficMarkerInfoWindowHtmlContent(topHitModel));
          trafficAlertsMarker.push(marker);
        }
      }
    }

    return trafficAlertsMarker;
  }

  private removeDuplicateSortTrafficAlertOnSameLocation(topHits: Array<any>): Array<any> {
    const orderedList: Array<any> = [];
    const tempObj: any = {};
    const orderList: Array<any> = [];

    topHits.forEach(hit => {
      const index = this.incidentOrder.indexOf(hit.aaIncidentType);
      orderedList[index] = hit;
    });

    orderedList.forEach(hit => {
      const name = '_' + hit.lat + hit.lon;
      if (!tempObj[name]) {
        tempObj[name] = hit;
        orderList.push(hit);
      }
    });

    return orderList;
  }

}
